import { type TestId } from '@repo/test-id';

import LogoutButton from '@features/account/components/LogoutButton';

import accountBottomIllustration from '@assets/images/account/account-bottom-illustration.webp';

interface Props {
  testId: TestId;
}

export default function SignOutSection({ testId }: Props) {
  return (
    <div className="relative mt-auto flex flex-col items-center" data-testid={testId}>
      <LogoutButton testId={testId.append('logoutButton')} />
      <img src={accountBottomIllustration} className="aspect-7/2 w-full object-cover object-top" alt="" aria-hidden />
    </div>
  );
}
